<ng-template #tabNavigation
	><div class="tabNavigation container-fluid">
		<ng-container *ngIf="refs.length > 1">
			<div
				*ngFor="let instance of refs"
				(click)="!disabled && setActive(instance.id)"
				class="flex-col expander-tab"
				[class.active]="instance.id === activeTab"
				[class.inactive]="instance.id !== activeTab"
				[class.disabled]="disabled"
				[class.flagged-error]="hasFlag(instance.id, 'error')"
			>
				{{ instance.label || '' | translate }}
			</div>
		</ng-container>
	</div>
</ng-template>
<ng-container *ngIf="tabNavigationPlacement === 'outside'" [ngTemplateOutlet]="tabNavigation"></ng-container>
<div class="tab-wrapper">
	<div class="tab-header"><ng-content select="[tab-header]"></ng-content></div>
	<ng-container *ngIf="tabNavigationPlacement === 'inside'" [ngTemplateOutlet]="tabNavigation"></ng-container>
	<div class="tab-content"><ng-container #container></ng-container></div>
	<div class="tab-footer"><ng-content select="[tab-footer]"></ng-content></div>
</div>
